export default __webpack_public_path__ + "static/media/LAVA-HT.d014bdd2.svg";